import { FC, useEffect } from "react";
import "../CSS/CalendarDetailScreen.css";
import backIcon from "../../../assets/images/back-icon.svg";
import locationIcon from "../../../assets/images/location-icon.svg";
import starIcon from "../../../assets/images/communicate-star-icon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import ImageCarousel from "components/elements/ImageCarousel";
import { CALENDAR_RESERVATION_TYPE, MENU_ITEM } from "utils/constants";
import { useTabBar } from "services/TabBarProvider";
import { IMAGE_LINK, WEB_LINK } from "utils/strings";
import { useLogout } from "services/LogoutProvider";
import ROUTE_PATHS from "utils/routePaths";
import { trackDetailView } from "utils/analytics";

const InnovativeSpaceDetailScreen: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { handleAppExit } = useLogout();
  const { setSelectedTabBar } = useTabBar();

  useEffect(() => {
    trackDetailView("innovative_space", "INNOVATIVE_SPACE");
  }, []);

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const handleReserveClick = () => {
    const fromPath = (location.state as { from?: string } | null)?.from;
    if (
      fromPath === ROUTE_PATHS.WSM_UR_MEMBERSHIP_PLAN_DETAIL ||
      fromPath === ROUTE_PATHS.WSM_MEMBERSHIP_PLAN_DETAIL
    ) {
      navigate(-2);
    } else {
      navigate(-1);
    }
    sessionStorage.setItem(
      "calendarSelectedTab",
      CALENDAR_RESERVATION_TYPE.DF_WORKSPACE,
    );
    setSelectedTabBar(MENU_ITEM.CALENDAR);
  };

  const openWorkspaceLocation = () => {
    handleAppExit(WEB_LINK.SABE_LOCATION);
  };

  return (
    <div className="wms-mobile-container">
      <div className="calendar_detail-screen-container">
        <div className="calendar_detail-header-container">
          <img
            src={backIcon}
            alt="dropdown-logo"
            className="image"
            onClick={handleBackButtonClick}
          />
          <span>
            Innovate <span style={{ color: "#ff6b35" }}>Space</span>
          </span>
        </div>
        <div
          className="calendar-detail-banner-image-container"
          style={{ backgroundImage: `url(${IMAGE_LINK.INNOVATIVE_SPACE})` }}
        ></div>
        <div className="calendar_detail-date-location-container">
          <div className="detail-container">
            <div className="image">
              <img src={locationIcon} alt="location-logo" />
            </div>
            <div className="right-container">
              <div className="sub-container">
                <span>SabeHub, Mohali</span>
                <span className="sub-text">SCO-4, 2nd Floor, Sec-68</span>
              </div>
              <button onClick={openWorkspaceLocation}>Direction</button>
            </div>
          </div>
        </div>
        <div className="calendar_detail-container">
          <span>
            About <span style={{ color: "#ff6b35" }}>Innovate Space</span>
          </span>
          <div className="divider"></div>
          <div className="communicate_space_container ">
            <span style={{ color: "#ff6b35" }}>Description</span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Innovate Space is built for
              focused execution.
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Use it when you already
              know what needs to move forward and need the right environment to
              stay focused, build momentum, and execute without unnecessary
              noise.
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> With ergonomic chairs,
              focused workstations, and a calm aesthetic, Innovate Space helps
              you work longer, think sharper, and leave with visible progress.
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Come here when your idea
              needs action.
            </span>
            <span style={{ marginTop: "10px", color: "#ff6b35" }}>
              Key Benefits
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Move important work forward
              without constantly switching context
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Stay focused longer in a
              setup designed for serious execution
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Leave with visible
              progress, not just hours spent at a desk
            </span>
            <span style={{ marginTop: "10px", color: "#ff6b35" }}>
              Features
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Ergonomic chairs for longer
              focused work sessions
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Focused workstations for
              laptop work, deep work, and execution
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Calm aesthetic that feels
              intentional, not corporate or crowded
            </span>
            <span className="sub_text">
              <img src={starIcon} alt="star-logo" /> Designed for founders,
              remote workers, freelancers, and operators who need serious focus
            </span>
          </div>
        </div>
        <div className="calendar_detail-contact-detail-container">
          <ImageCarousel
            images={[
              IMAGE_LINK.INNOVATIVE_SPACE_1,
              IMAGE_LINK.INNOVATIVE_SPACE_2,
              IMAGE_LINK.INNOVATIVE_SPACE_3,
              IMAGE_LINK.INNOVATIVE_SPACE_4,
            ]}
            title="In Real"
            subTitle="Life"
          />
        </div>
        <button
          className="calendar_detail-reserve-btn"
          onClick={handleReserveClick}
        >
          Reserve Now
        </button>
      </div>
    </div>
  );
};

export default InnovativeSpaceDetailScreen;
